'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectIsAuthenticated } from '@repo/store/maps/slices/auth';
import { selectTeleportCtaPinId, setTeleportCtaPinId } from '@repo/store/maps/slices/clientContext';
import { selectCurrentMapInfo } from '@repo/store/maps/slices/mapData';
import { HostType } from '@repo/types/host';
import { useCallback, useEffect, useRef } from 'react';
interface UseTeleportCtaOptions {
  selectedLocationId?: string | null;
}
export function useTeleportCta(t0) {
  const $ = _c(34);
  const {
    selectedLocationId
  } = t0;
  const analytics = useAnalytics();
  const dispatch = useAppDispatch();
  const hostType = useHostType();
  const pinId = useAppSelector(selectTeleportCtaPinId);
  const currentMap = useAppSelector(selectCurrentMapInfo);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isOpen = hostType === HostType.WEB && pinId === selectedLocationId;
  const wasOpenRef = useRef(false);
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => dispatch(setTeleportCtaPinId(null));
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const close = t1;
  let t2;
  let t3;
  if ($[2] !== close || $[3] !== hostType || $[4] !== pinId || $[5] !== selectedLocationId) {
    t2 = () => {
      if (pinId && (hostType !== HostType.WEB || pinId !== selectedLocationId)) {
        close();
      }
    };
    t3 = [close, hostType, pinId, selectedLocationId];
    $[2] = close;
    $[3] = hostType;
    $[4] = pinId;
    $[5] = selectedLocationId;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== analytics || $[9] !== currentMap?.externalId || $[10] !== currentMap?.name || $[11] !== currentMap?.titleId || $[12] !== hostType || $[13] !== isAuthenticated || $[14] !== isOpen || $[15] !== pinId) {
    t4 = () => {
      if (!isOpen || !pinId) {
        wasOpenRef.current = false;
        return;
      }
      if (wasOpenRef.current) {
        return;
      }
      wasOpenRef.current = true;
      analytics.event("game_map_teleport_cta_impression", {
        mapId: currentMap?.externalId,
        titleId: currentMap?.titleId,
        titleName: currentMap?.name,
        locationId: pinId,
        platform: hostType,
        isAuthenticated
      });
    };
    $[8] = analytics;
    $[9] = currentMap?.externalId;
    $[10] = currentMap?.name;
    $[11] = currentMap?.titleId;
    $[12] = hostType;
    $[13] = isAuthenticated;
    $[14] = isOpen;
    $[15] = pinId;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== analytics || $[18] !== currentMap || $[19] !== hostType || $[20] !== isAuthenticated || $[21] !== isOpen || $[22] !== pinId) {
    t5 = [analytics, currentMap, hostType, isAuthenticated, isOpen, pinId];
    $[17] = analytics;
    $[18] = currentMap;
    $[19] = hostType;
    $[20] = isAuthenticated;
    $[21] = isOpen;
    $[22] = pinId;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  useEffect(t4, t5);
  let t6;
  if ($[24] !== analytics || $[25] !== currentMap || $[26] !== hostType || $[27] !== isAuthenticated || $[28] !== pinId) {
    t6 = () => {
      if (!pinId) {
        return;
      }
      analytics.event("game_map_teleport_cta_download_click", {
        mapId: currentMap?.externalId,
        titleId: currentMap?.titleId,
        titleName: currentMap?.name,
        locationId: pinId,
        platform: hostType,
        isAuthenticated
      });
      if (!currentMap) {
        return;
      }
      analytics.event("game_map_web_download_wemod_teleport_click", {
        mapId: currentMap.externalId,
        titleId: currentMap.titleId,
        titleName: currentMap.name,
        platform: hostType
      });
    };
    $[24] = analytics;
    $[25] = currentMap;
    $[26] = hostType;
    $[27] = isAuthenticated;
    $[28] = pinId;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const handleDownloadClick = t6;
  let t7;
  if ($[30] !== close || $[31] !== handleDownloadClick || $[32] !== isOpen) {
    t7 = {
      close,
      handleDownloadClick,
      isOpen
    };
    $[30] = close;
    $[31] = handleDownloadClick;
    $[32] = isOpen;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  return t7;
}